<template>
  <div>

    <!-- Top Info Grid -->
    <section class="top-info py-2">
      <b-container>
        <b-row class="text-center align-items-center">
          <b-col md="4" class="info-item">
            <strong>Our Office</strong><br />
            <small>laaga rd 4 elepe ikorodu, Lagos stste</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Email Us</strong><br />
            <small>olaleresomod24@gmail.com</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Contact Us</strong><br />
            <small>+234 800 123 4567</small>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- NAVBAR -->
    <b-navbar toggleable="lg" type="dark" variant="dark" class="bg-dark">
      <b-navbar-brand to="/">JEWELUX</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/shop">Shop</b-nav-item>
          <b-nav-item to="/about">About Us</b-nav-item>
          <b-nav-item to="/partners">Partners</b-nav-item>
          <b-nav-item to="/contact">contacts</b-nav-item>
          <b-nav-item to="/cart">cart</b-nav-item>
        </b-navbar-nav>


      </b-collapse>
    </b-navbar>

    <!-- Hero Section -->
    <b-jumbotron header="Contact Us" lead="We’d love to hear from you!">
      <p>Fill out the form below or reach us through our contact details.</p>
    </b-jumbotron>

    <!-- Contact Form + Map -->
    <b-container class="my-5">
      <b-row>
        <!-- Form Section -->
        <b-col md="6">
          <h2>Send a Message</h2>
          <b-form @submit.prevent="handleSubmit" ref="form">

            <b-form-group label="Name" label-for="nameInput" description="Enter your full name.">
              <b-form-input id="nameInput" v-model="form.name" required placeholder="Your Name"></b-form-input>
            </b-form-group>

            <b-form-group label="Email" label-for="emailInput" description="Enter your email.">
              <b-form-input id="emailInput" type="email" v-model="form.email" required
                placeholder="your@email.com"></b-form-input>
            </b-form-group>

            <b-form-group label="Message" label-for="messageInput" description="Your message.">
              <b-form-textarea id="messageInput" v-model="form.message" required
                placeholder="Write your message here..." rows="5"></b-form-textarea>
            </b-form-group>

            <b-button type="submit" variant="primary">Send Message</b-button>
          </b-form>
        </b-col>

        <!-- Map Section -->
        <b-col md="6" class="mt-4 mt-md-0">
          <h2>Our Location</h2>
          <div class="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.123456789!2d7.123456!3d9.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sYour+Store!5e0!3m2!1sen!2sng!4v1670000000000"
              width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </b-col>
      </b-row>
    </b-container>




    <!-- Modern Footer -->
    <b-container fluid class="bg-dark text-white pt-5 pb-3">
      <b-row class="text-center text-md-left">

        <!-- Brand / Logo -->
        <b-col md="3" class="mb-4">
          <h4 class="text-gold font-weight-bold">JEWELUX</h4>
          <p class="small">Luxury handcrafted jewelry for every occasion.</p>
        </b-col>

        <!-- Quick Links -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Quick Links</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white">Home</a></li>
            <li><a href="#" class="text-white">Shop</a></li>
            <li><a href="#" class="text-white">About</a></li>
            <li><a href="#" class="text-white">Contact</a></li>
          </ul>
        </b-col>

        <!-- Social Media -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Follow Us</h5>
          <div>
            <b-icon icon="facebook" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="instagram" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="twitter" font-scale="1.5" class="mr-2 text-white"></b-icon>
          </div>
        </b-col>

        <!-- Newsletter -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Newsletter</h5>
          <b-form @submit.prevent="subscribe">
            <b-input-group size="sm">
              <b-form-input v-model="email" type="email" placeholder="Your email" required></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="gold">Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col class="text-center small">
          &copy; 2026 JEWELUX. All rights reserved.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>


export default {
  components: {},
  data() {
    return {
      form: {
        name: "",
        email: "",
        message: ""
      }
    };
  },
  methods: {
    handleSubmit() {
      if (!this.form.name || !this.form.email || !this.form.message) {
        alert("Please fill in all fields.");
        return;
      }

      // Basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.form.email)) {
        alert("Please enter a valid email.");
        return;
      }

      alert(`Thank you, ${this.form.name}! Your message has been sent.`);
      // Reset form
      this.form.name = "";
      this.form.email = "";
      this.form.message = "";
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.map-container iframe {
  border-radius: 8px;
}

/* Footer Styling */
.text-gold {
  color: #bfa14b;
}

a.text-white:hover {
  color: #bfa14b;
  text-decoration: none;
}

.bg-dark {
  background-color: #1a1a1a !important;
}
</style>
